/**
 * 信息披露
 */
export default [
  {
    path: '/info/announce/:id',
    meta: {
      title: '平台公告',
    },
    component: (resolve) => {
      require(['$views/info/announce-detail.vue'], resolve)
    }
  },
  {
    path: '/info',
    meta: {
      title: '信息披露'
    },
    redirect: '/info/company-profile',
    component: (resolve) => {
      require(['$views/info/index.vue'], resolve)
    },
    children: [
      {
        path: '/info/company-profile',
        meta: {
          title: '公司简介',
        },
        component: (resolve) => {
          require(['$views/info/company-profile.vue'], resolve)
        }
      },
      {
        path: '/info/management-team',
        meta: {
          title: '管理团队',
        },
        component: (resolve) => {
          require(['$views/info/management-team.vue'], resolve)
        }
      },
      {
        path: '/info/company-honor',
        meta: {
          title: '荣誉资质',
        },
        component: (resolve) => {
          require(['$views/info/company-honor.vue'], resolve)
        }
      },
      {
        path: '/info/data-disclosure',
        meta: {
          title: '数据披露',
        },
        component: (resolve) => {
          require(['$views/info/data-disclosure.vue'], resolve)
        },
        redirect: '/info/data-disclosure/current',
        children: [
          {
            path: '/info/data-disclosure/current',
            meta: {
              title: '数据披露',
            },
            component: (resolve) => {
              require(['$views/info/current-data-disclosure.vue'], resolve)
            },
          },
          {
            path: '/info/data-disclosure/history',
            meta: {
              title: '数据披露',
            },
            component: (resolve) => {
              require(['$views/info/history-data-disclosure.vue'], resolve)
            },
          }
        ]
      },
      {
        path: '/info/mouthly-report-list',
        meta: {
          title: '运营月报',
        },
        component: (resolve) => {
          require(['$views/info/mouthly-report-list.vue'], resolve)
        }
      },
      {
        path: '/info/risk-management',
        meta: {
          title: '风险管理',
        },
        component: (resolve) => {
          require(['$views/info/risk-management.vue'], resolve)
        }
      },
      {
        path: '/info/bank-deposit',
        meta: {
          title: '银行存管',
        },
        component: (resolve) => {
          require(['$views/info/bank-deposit.vue'], resolve)
        }
      },
      {
        path: '/info/audit-info',
        meta: {
          title: '审计信息',
        },
        component: (resolve) => {
          require(['$views/info/audit-info.vue'], resolve)
        }
      },
      {
        path: '/info/major-matters',
        meta: {
          title: '重大事项',
        },
        component: (resolve) => {
          require(['$views/info/major-matters.vue'], resolve)
        }
      },
      {
        path: '/info/law',
        meta: {
          title: '法律法规',
        },
        component: (resolve) => {
          require(['$views/info/law.vue'], resolve)
        }
      },
      {
        path: '/info/contract',
        meta: {
          title: '平台公告',
        },
        component: (resolve) => {
          require(['$views/info/contract.vue'], resolve)
        }
      },
      {
        path: '/info/operation-report',
        meta: {
          title: '运营报告',
        },
        component: (resolve) => {
          require(['$views/info/operation-report.vue'], resolve)
        }
      },
      {
        path: '/info/operation-report/operation-report-2017',
        meta: {
          title: '运营报告',
        },
        component: (resolve) => {
          require(['$views/info/operation-report-2017.vue'], resolve)
        }
      },
      {
        path: '/info/operation-report/operation-report-2018',
        meta: {
          title: '运营报告',
        },
        component: (resolve) => {
          require(['$views/info/operation-report-2018.vue'], resolve)
        }
      },
      {
        path: '/info/contact-us',
        meta: {
          title: '联系我们',
        },
        component: (resolve) => {
          require(['$views/info/contact-us.vue'], resolve)
        }
      },
      {
        path: '/info/pdf',
        meta: {
          title: '法人确认函',
        },
        component: (resolve) => {
          require(['$views/info/confirmation-letter.vue'], resolve)
        }
      }
    ]
  },

]



// WEBPACK FOOTER //
// ./src/routes/modules/info.js